<template>
  <b-button-group>
    <b-button
      :class="{ active: selected === 'colleges' }"
      @click="navigateTo('colleges')"
    >
      Colleges
    </b-button>
    <b-button
      :class="{ active: selected === 'college-admins' }"
      @click="navigateTo('college-admins')"
    >
      College Admins
    </b-button>
    <b-button
      :class="{ active: selected === 'students' }"
      @click="navigateTo('students')"
    >
      Students
    </b-button>
    <b-button
      :class="{ active: selected === 'counselors' }"
      @click="navigateTo('counselors')"
    >
      Counselors
    </b-button>
  </b-button-group>
</template>

<script>
export default {
  name: 'AccountTypeTabs',

  props: {
    selected: {
      type: String,
      required: true
    }
  },

  methods: {
    navigateTo(page) {
      this.$router.push({ name: `accounts-${page}` });
    }
  }
};
</script>
